import { btnStyle } from '@bingads-webui-campaign-react/common-styles';

export const getBudgetSuggestionPopupStyle = (palette = {}) => ({
  '.budget-landscape-container-outer': {
    width: '1200px',
    border: '0 solid',
    borderRadius: '2px',
    backgroundColor: '#fff',
    boxShadow: '0 25.6px 57.6px 0 rgba(0,0,0,.22), 0 4.8px 14.4px 0 rgba(0,0,0,.18)',

    '& .budget-landscape-dismiss-popup': {
      right: 10,
      bottom: 70,
      zIndex: '2000',

      '& .single-choice-feedback-form': {
        width: 408,
        padding: 20,
        boxShadow: '0 0 5px #ccc',
        backgroundColor: '#fff',
        position: 'absolute',
        right: -150,
        bottom: -100,
        '& .close': {
          right: 25,
        },
        '& .single-choice-feedback-form-head': {
          paddingLeft: 8,
          '& .single-choice-feedback-form-title': {
            width: 392,
            fontWeight: 'bold',
            fontSize: '20px',
          },
          '& .single-choice-feedback-form-description': {
            color: '#797775',
          },
        },
        '& .reason-input': {
          marginLeft: 8,
          '& .input-wrapper': {
            position: 'relative',
          },
          '& .percent-suffix': {
            position: 'absolute',
            top: '5px',
            left: '80px',
          },
          '& .percent-input': {
            width: 98,
            paddingRight: '20px',
          },
          '& .number-input': {
            width: 98,
          },
          '& .input-comment': {
            paddingTop: 6,
            paddingBottom: 6,
          },
        },
        '& p, & .radio': {
          paddingLeft: 10,
          fontFamily: '\'Segoe UI\', Arial, sans-serif',
          '&[data-checked=true]': {
            backgroundColor: '#DEECF9',
          },
          '& button:disabled': {
            color: '#a2a2a2',
            backgroundColor: palette.themePrimary,
            border: '1px solid #0078d4',
          },
        },
        '& .form-group': {
          marginBottom: '0px !important',
          marginTop: 10,
        },
        '& div.comments': {
          '& textarea': {
            height: 72,
            width: 296,
            border: '1px #bbb solid',
            background: '#fff',
            marginBottom: 5,
          },
        },
        '& .actions': {
          paddingTop: 8,
          '& .submit': {
            marginLeft: 5,
            marginRight: 10,
          },
          '& .checkbox.preference': {
            paddingTop: 12,
            color: '#bbb',
            paddingLeft: 10,
            '& .not-show-again-text': {
              paddingLeft: 8,
              width: 312,
              display: 'inline-block',
              verticalAlign: 'top',
            },
          },
        },
        '& .error': {
          color: '#A80000', // error-icon color in color.less file
          fontSize: '12px',
        },
      },
    },

    '& .budgetlandscape-seasonal-title': {
      backgroundColor: 'lightgray',
      width: 1200,
      height: 30,
      marginTop: -24,
      '& .budgetlandscape-seasonal-title-text': {
        lineHeight: '30px',
        marginTop: 0,
        marginLeft: 10,
        fontSize: 14,
      },
      '& .closeimage': {
        marginRight: 10,
        marginTop: 2,
      },
    },

    '& .budget-landscape.panel': {
      marginBottom: '0px',
      '& .panel-outer-body': {
        padding: '25px 15px 10px 15px',
      },
      '& .budget-landscape-actions': {
        '& .btn-hero': {
          marginRight: '7px',
        },
      },
      '& .budget-landscape-actions .btn-hero': btnStyle({ palette })['.btn-hero'],
      '& .budget-landscape-actions .btn-default': btnStyle({ palette })['.btn-default'],

      '& .with-feedback-footer': {
        borderTop: '1px solid #EDEBE9',
        padding: 16,
        height: 64,
        '& .budget-landscape-actions': {
          float: 'left',
        },
        '& .budget-landscape-feedback-actions': {
          float: 'right',
          paddingRight: '20px',
          '& .iconba': {
            verticalAlign: 'middle',
            fontSize: 20,
            marginRight: 20,
          },
          '& .iconba-LikeSolid': {
            color: '#106EBE',
          },
          '& .navigate-to-recommended-page-link': {
            verticalAlign: 'middle',
          },
          '& .feedback-comment': {
            verticalAlign: 'middle',
          },
          '& .budget-landscape-like': {
            marginLeft: 30,
          },
          '& .budget-landscape-dislike': {
            transform: 'rotate(180deg)',
            marginLeft: 10,
          },
        },
      },

      '& .budgetlandscape-title': {
        marginTop: '0px',
        marginBottom: '5px',
        paddingLeft: '10px',
        fontSize: '15px',
        fontWeight: 'bold',
      },

      '& .close.closeimage': {

      },

      '& .panel-body': {
        padding: '15px 10px',

        '& .budgetlandscape-helptext': {
          fontSize: '14px',
          fontWeight: 'normal',
          margin: '0px',
        },

        '& .budget-landscape-div': {
          marginTop: '25px',

          '& .budget-landscape-container': {
            display: 'grid',
            gridTemplateColumns: '68% auto',

            '& .landscape-table': {
              marginRight: '20px',

              '& > div': {
                position: 'relative',
              },

              '& .tip-message': {
                marginTop: '15px',

                '& .iconba.iconba-Warning': {
                  color: '#D83B01 !important',
                },
              },

              '& span.status': {
                marginRight: '5px',
              },

              '& tr': {
                height: '30px',

                '&.selected': {
                  backgroundColor: '#DEECF9',

                  '&::after': {
                    borderBottom: '15px solid transparent',
                    borderLeft: '25px solid #e5f7f4',
                    borderTop: '15px solid transparent',
                    height: '0',
                    width: '0',
                    content: '" "',
                    position: 'absolute',
                  },
                },
              },

              '& th': {
                fontWeight: 'normal',
                padding: '0px 10px',

                '&.selected': {
                  fontWeight: 'bold',
                  backgroundColor: 'rgba(237, 237, 237, 0.5)',
                },
              },

              '& td': {
                padding: '0px 10px',

                '&.selected': {
                  backgroundColor: 'rgba(237, 237, 237, 0.5)',
                },

                '& input[type=radio]': {
                  '&::before': {
                    left: '10px !important',
                  },
                  '&::after': {
                    left: '12px !important',
                  },
                },
              },
              '& td.user-input-cell': {
                padding: 0,
                '& .user-input': {
                  position: 'relative',
                  '& .currency-symbol': {
                    position: 'absolute',
                    left: 10,
                    top: 3,
                  },
                  '& input': {
                    width: 135,
                    paddingLeft: 16,
                  },
                  '& .symbol-size-2 + input': {
                    paddingLeft: 25,
                  },
                  '& .symbol-size-3 + input': {
                    paddingLeft: 35,
                  },
                },
              },
              '& .error-message': {
                color: '#a80000',
              },
            },

            '& .landscape-chart': {
              marginLeft: '15px',
              marginRight: '15px',
              display: 'grid',

              '& .column-chart-title': {
                paddingTop: '4px',
                paddingBottom: '4px',
                display: 'grid',
              },
            },
          },
        },

        '& .more-suggestion': {
          marginBottom: '10px',
        },
      },
    },
  },
  '#delivery-status-popup-callout .popover-content': {
    padding: '15px',
    lineHeight: '16px',
    color: '#333333',
    '& .description-text.bold.margin-zero': {
      fontWeight: 'bold',
      lineHeight: '14px',
      marginBottom: '8px',
    },
    '& .description-text.margin-bottom-8': {
      marginBottom: '8px',
    },
    '& a.budget-center-view-link': {
      lineHeight: '20px',
      textDecoration: 'none',
    },
  },
});
